import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import swal from 'sweetalert2';  

import { PdfMakeWrapper,Table,Img} from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// importing definitions
import { Txt,Columns,Ul,Ol } from 'pdfmake-wrapper';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss']
})
export class PerfilComponent implements OnInit {
  @ViewChild('cloper',null) cloper;
  @ViewChild('clochart',null) clochart;
  @ViewChild('pdf', {static: false}) pdf: any; 
  
  constructor(
    private http: HttpClient,
    public authService: AuthService,
    public router: Router,
    private route: ActivatedRoute
    ) { }
    perfil;
    caller;
  ngOnInit() {
    this.route.queryParams.subscribe(params => { this.caller = params.caller; });   
    this.perfil=JSON.parse(localStorage.getItem("perfil"));
   
    this.get_org();
    this.id_persona=this.perfil.id_persona;
    
    this.ls_persona();    
    this.id_role=this.persona.id_role;
  
  
    this.ls_competencia_trinity();

    this.selsiz = { nombre:"Tabloid" };
    this.selori = { nombre:"true", valor:true };
    this.selscale = { nombre: .1 };

    this.margin.push
      ({ 
        top: this.itmmargin.top.toString()+"cm", 
        bottom:this.itmmargin.bottom.toString()+"cm", 
        right:this.itmmargin.right.toString()+"cm", 
        left:this.itmmargin.left.toString()+"cm",
      });
  }
  bndemail=true; 
  bndtelefono=true;
  bndcelular=true;
  t_email(){this.bndemail=!this.bndemail;this.bndtelefono=true;this.bndcelular=true;}
  t_telefono(){this.bndtelefono=!this.bndtelefono;this.bndemail=true;this.bndcelular=true;}
  t_celular(){this.bndcelular=!this.bndcelular;this.bndemail=true;this.bndtelefono=true;} 
  gda_contacto(t){
    var valor=""
    switch (t) {
      case "celular":
        valor=this.persona.celular==null?"":this.persona.celular
        break;
      case "telefono":
        valor=this.persona.telefono==null?"":this.persona.telefono;        
        break;
      case "email":
        valor=this.persona.email==null?"''":"'"+this.persona.email+"'"
        break;
    }
    let postData = {
      id:this.id_persona,
      campo:t,
      valor:valor
      
    } 
    this.hidCvePersona=this.persona.id;
    console.log(postData);
    this.authService.service("/api/upd_persona_contacto",postData)
    .then(
        data => {          
         swal.fire('ok', '', 'success');
         this.ls_persona();
         this.bndemail=true; 
         this.bndtelefono=true;
         this.bndcelular=true;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            
            swal.fire('¡API incorrecta!'+de, '', 'error');
        });
  }
  gda_persona(){
    if (this.valida_per2()==true){
      let postData = {
        id:this.id_persona,
        nombre:this.persona.nombre,
        paterno:this.persona.paterno,
        materno:this.persona.materno,
        profesion:this.persona.profesion,
        email:this.persona.email==null?"":this.persona.email,
        celular:this.persona.celular==null?"":this.persona.celular,
        telefono:this.persona.telefono==null?"":this.persona.telefono,
        ingreso:this.persona.fec_ingreso,
        foto:this.persona.foto,
        chart:Number(this.persona.chart),
      } 
      this.hidCvePersona=this.persona.id;
      console.log(postData);
      this.authService.service("/api/upd_persona",postData)
      .then(
          data => {
            
            this.VentanaFix=0;
            this.uploadFileToActivity();
            this.cloper.nativeElement.click();
           swal.fire('ok', '', 'success');
           this.ls_persona();
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              
              swal.fire('¡API incorrecta!'+de, '', 'error');
          });
    }
  }

  role_card;
    ls_role(){
        let postData = {role_id:this.id_role }         
        this.authService.service("/api/get_rolecard_id",postData)
        .then(
            data => { 
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);
             
              this.role_card=res[0];
              console.log("role_card_id111")
              console.log(this.role_card)
              this.persona.puesto=this.role_card.titulo;
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡API incorrecta!', '', 'error');
            });
      
    }    
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
    id_persona=0;
    id_perosna_box=0;
    nineb=0;
    per_box_=[];
    loading=false;
    _competences_9b=[];
    _goals_9b=[];
    cancel_nvoidp(){
      this.idp_v=true;
    }
    fn_nvo_goal_hk(){
      
      //this.metashk.push({id:1,hk:"ok",nombre:"12"})
      let postData = {
        id_role:this.id_role
      };
      console.log(postData);
      this.authService.service("/api/metas_hk",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);       
            this.metashk=res;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! idp', '', 'error');
          });    
    
      
      this.goal_v=true;
      this.bndgoal_hk=true;
      this.goal_e=false;
      this.goal_n=false;
    }
    id_role;
    rpt_hk(itm){
      console.log(itm)
      localStorage.setItem("t_hk","X");
      localStorage.setItem("nivel","1");
      localStorage.setItem("duenio_id",this.id_role);
      localStorage.setItem("duenio","");
      localStorage.setItem("fecha","");
      localStorage.setItem("superv","");
      localStorage.setItem("id_hk",itm.id_hk);
      this.router.navigate([]).then(result => {  window.open('./#/fmt_hk', '_blank'); }); 
    
    }
    date_goal:any;
    fn_edit_idp(itm){
      this.idp_v=false;
      this.idp_.id=itm.id;
      this.idp_.skill=itm.id_competencia;
      this.idp_.trainig=itm.actividades;
      try {
        this.idp_.fecha=itm.fecha.substring(0,10);  
      } catch (error) {
        this.idp_.fecha="";
      }
      
      this.idp_.costos=itm.costo;
      this.idp_.resultados=itm.resultado;
      this.idp_.estatus=itm.estado;
      this.idp_a=true;
    }
    fn_nvo_idp(){
      this.idp_.id=0;
      this.idp_.skill=0;
      this.idp_.trainig="";
      this.idp_.fecha="";
      this.idp_.costos=0;
      this.idp_.resultados="";
      this.idp_.estatus="A";
    
      this.idp_v=false;
      this.idp_a=false;
    }
    total_goals=0;
    total_competences=0;
    tnineb;
    view_nineb(t){
      this.tnineb=t
      this.det_box=true;
      let postData = {
        id_persona:this.persona.id,
        id_evaluador:this.id_perosna_box
      };
      //console.log(postData);
     var a="";
      switch (t) {
        case 'C':
          a="/api/nine_box";
          break;
        case 'L':
          a="/api/nine_box_last";
            break;  
        default:
          break;
      }
      this.authService.service(a,postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            //console.log(res);
            this.nineb=res[0].nineb;
            //this._eval_=res;
            this.loading=false;
            this._box.titulo="Nine Box ";
            this._box.contenido="Medición y evaluación de Competencias  "+
              " <br><span class='green'>Competences=<b>"+res[0].competence+"</b></span>"+
              " <br><span class='green'>Goals=<b>"+res[0].goals+"%</b> </span>";
            this._box.numero=1;
            this.total_goals=res[0].goals;
            this.total_competences=res[0].competence;
    
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta!', '', 'error');
              this.loading=false;
          });

          console.log("tot:goals"+this.total_goals);
    
    }
    det_box=false;
    _box={
      titulo:"",
      contenido:"",
      numero:0
    };
    perbox(id){
      let postData = {
        id_persona:id
      };
      this.authService.service("/api/get_per_box",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);   
            this.per_box_=res;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta!', '', 'error');
              this.loading=false;
          });
    
    }
    gda_assessment(){

    }
    ver_9B(){
      this.ls_goals()
      this.fn_competencias_t()
       this.persona.id=this.id_persona;
       this.perbox(this.id_persona);
       this.nineb=0;
    }
    ver_role_card(itm){
      this.bndedita_persona=false;
      this.id_persona=itm.id;  
      this.persona={
        id:itm.id, 
        id_role:0, 
        foto:itm.foto,
         nombre:itm.nombre,
         paterno:itm.apaterno,
         materno:itm.amaterno,
         email:itm.email,
         telefono:itm.telefono,
         celular:itm.celular,
         puesto:"",//itm.puesto,
         profesion:itm.profesion,
         fec_ingreso:itm.fec_ingreso,     
         chart:0
       };
      this.VentanaFix=2;
    }
    ver_role(itm){
      this.id_persona=itm.id;  
      this.persona={
        id:itm.id, 
        id_role:0, 
        foto:itm.foto,
         nombre:itm.nombre,
         paterno:itm.apaterno,
         materno:itm.amaterno,
         email:itm.email,
         telefono:itm.telefono,
         celular:itm.celular,
         puesto:"",//itm.puesto,
         profesion:itm.profesion,
         fec_ingreso:itm.fec_ingreso,     
         chart:0
       };
      //this.VentanaFix=1;
    }
    
    VentanaFix=0;
    id_cliente=0;
    _persona;
    test($event){
      console.log("test");
      
      var res=JSON.parse($event.cssClass);
      console.log(res);
      if(res.id_persona==null){        
        swal.fire('¡Puesto sin perfil asignado!', '', 'warning');
      }else{
        //localStorage.setItem("perfil",$event.cssClass);
        //this.router.navigate(["/perfil"]);
        this.perfil=JSON.parse($event.cssClass);   
        this.get_org();
        this.id_persona=this.perfil.id_persona;        
        this.ls_persona();    
        this.id_role=this.persona.id_role;
        this.ls_competencia_trinity();
        this.clochart.nativeElement.click();
      }      
      return;
    }
    ls_persona(){
      let postData = {id_persona:this.id_persona } 
      console.log(postData);
      this.authService.service("/api/get_persona_id",postData)
      .then(
          data => { 
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            console.log("get_persona_id");            
            console.log(res);            
            var f="";
            if(res[0].foto=="")f="image-none.jpg"
            else f=res[0].foto;
            this.id_role=res[0].id_role;
            this.persona={
              id:res[0].id, 
              id_role:res[0].id_role, 
              foto:f,
               nombre:res[0].nombre,
               paterno:res[0].apaterno,
               materno:res[0].amaterno,
               profesion:res[0].profesion,
               email:res[0].email,
               telefono:res[0].telefono,
               celular:res[0].celular,
               puesto:res[0].puesto,
               fec_ingreso:res[0].ingreso,     
               chart:0
             };
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });
    }
    eli_role(itm){
      if(confirm("Confirm to delete this record?")==false)return;
      let postData = {
        id:itm.id
      } 
      this.authService.service("/api/eli_persona_cliente",postData)
      .then(
          data => {                
           swal.fire('ok', '', 'success');
           this.ls_persona();
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)            
              swal.fire('¡API incorrecta!'+de, '', 'error');
          });
    }
    fn_perfil(itm){
      var css='{"id_persona":'+itm.id+',"id_role":'+0+'}'
      localStorage.setItem("perfil",css);
      this.router.navigate(["/perfil"]);
    }
    bndedita_persona=false
    vf__persona(){
      this.bndedita_persona=true;
      this.persona.nombre="";
      this.persona.paterno="";
      this.persona.materno="";
      this.persona.profesion="";
      this.persona.fec_ingreso="";
    }
    nva_persona(){
      if (this.valida_per2()==true){
        let postData = {
          id:0,
          nombre:this.persona.nombre,
          paterno:this.persona.paterno,
          materno:this.persona.materno,
          profesion:this.persona.profesion,
          ingreso:this.persona.fec_ingreso,
          foto:"",
          chart:0,
          id_cliente:localStorage.getItem("id_cliente") 
        } 
        this.hidCvePersona=this.persona.id;
        //console.log(postData);
        this.authService.service("/api/ins_persona_cliente",postData)
        .then(
            data => {            
            this.VentanaFix=0;           
             swal.fire('ok', '', 'success');
             this.ls_persona();
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                
                swal.fire('¡API incorrecta!'+de, '', 'error');
            });
      }
    }
  
  
    idp_area:boolean=false;
    feed_area:boolean=false;
    feed_v:boolean=true;
    feedb;
    feed={
      id:0,
      periodo:0,
      evaluacion:0,
      descripcion:""
    };
    a_feed:boolean=true;
    fn_edit_feed(itm){
      this.feed.id=itm.id;
      this.feed.descripcion=itm.descripcion;
      this.feed.evaluacion=itm.evaluacion;
      this.feed.periodo=itm.periodo;
      this.feed_v=false;
      this.a_feed=false;
    }
    fn_can_feedb(){
      this.feed_area=false;
      this.idp_area=true;
    }
    upd_feed(){
      let postData = {
        id_idp:this.feed.id,
        periodo:this.feed.periodo,
        evaluacion:this.feed.evaluacion,
        descripcion:this.feed.descripcion
      };
      
      this.authService.service("/api/upd_feed",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            swal.fire('Ok', '', 'success');
            this.ls_feed(this.hidcve_idp);
           this.ls_idp(this.hidCvePersona);
           this.feed_v=true; 
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! upd-feed', '', 'error');
          });    
    
    }
    ins_feed(){
      let postData = {
        id_idp:this.hidcve_idp,
        periodo:this.feed.periodo,
        evaluacion:this.feed.evaluacion,
        descripcion:this.feed.descripcion
      };
      //console.log(postData);
      this.authService.service("/api/ins_feed",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            swal.fire('Ok', '', 'success');
           this.ls_feed(this.hidcve_idp);
           this.ls_idp(this.hidCvePersona);
           this.feed_v=true; 
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! ins-feed', '', 'error');
          });    
    }
    fn_nvo_feedb(){
      this.feed_v=false;
      this.a_feed=true;
      this.hidcve_feed=0;
      this.feed.periodo=0;
      this.feed.evaluacion=0;
      this.feed.descripcion="";
    }
    fn_cancel_feedb(){
      this.feed_v=true;
    }
    
    ls_feed(id){
      let postData = {
        id_idp:id
      };
      this.authService.service("/api/get_feed",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            this.feedb=data;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! idp', '', 'error');
          });    
    }
    hidcve_feed;
    hidcve_idp;
    feed_name;
    fn_feed_idp(itm){
      //console.log(itm)
      this.feed_name=' { '+itm.competencia + ' \ ' + itm.periodo_+' }';
      this.hidcve_idp=itm.id;
      this.ls_feed(itm.id);
      this.feed_area=true;
      this.feed_v=true;
      this.idp_area=false;
    }
    idp;
    
    txteducation:string="";
    edu=[];
    txtanio_:Number=2021;
    txtanio2_:Number=2021;
    p1;p2;p3;
  c1;c2;c3;c4;c5;c6;c7;c8;c9;c10;
  c11;c12;c13;c14;c15;c16;
    v_assesment(){
    this.p1="";this.p2="";this.p3="";         
    this.c1=0;this.c2=0;this.c3=0;this.c4=0;this.c5=0;this.c6=0;this.c7=0;this.c8=0;this.c9=0;this.c10=0;   
    this.c11=0;this.c12=0;this.c13=0;this.c14=0;this.c15=0;this.c16=0;   
    let postData = {  
      id_persona:this.id_persona
      
    }
    //console.log(postData);
    this.authService.service("/api/get_evaluacion_dpi",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                                
          this.loading=false;
          if(res.length>0){
            this.p1=res[0].p1;this.p2=res[0].p2;this.p3=res[0].p3;         
            this.c1=res[0].c1;this.c2=res[0].c2;this.c3=res[0].c3;this.c4=res[0].c4;this.c5=res[0].c5;this.c6=res[0].c6;this.c7=res[0].c7;this.c8=res[0].c8;this.c9=res[0].c9;this.c10=res[0].c10;   
            this.c11=res[0].c11;this.c12=res[0].c12;this.c13=res[0].c13;this.c14=res[0].c14;this.c15=res[0].c15;this.c16=res[0].c16;   
          }
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;
            swal.fire('¡API incorrecta! get_evaluacion_dpi', '', 'error');
      }); 
    }
    gda_assesment(){  
      this.loading=true;
      let postData = {
        id_persona:this.persona.id,
        p1:this.p1,p2:this.p2, p3:this.p3,    
        c1:this.c1,c2:this.c2,c3:this.c3,c4:this.c4,c5:this.c5,c6:this.c6,c7:this.c7,c8:this.c8,c9:this.c9,c10:this.c10,
        c11:this.c11,c12:this.c12,c13:this.c13,c14:this.c14,c15:this.c15,c16:this.c16,
      } 
        //console.log(postData);
        this.authService.service("/api/gda_evaluacion_dpi",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);                                
              this.loading=false;   
              swal.fire('ok', '', 'success');
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                this.loading=false;
                swal.fire('¡API incorrecta! gda_evaluacion_dpi', '', 'error');
          });  
    }
    competence_v:boolean=true;
    competence_v_t:boolean=true;
    per_competencia_t;
    Comp_t;
    ls_competencia_trinity(){
      let postData = {        
        id_cliente:localStorage.getItem("id_cliente")
      }
      this.authService.service("/api/get_competencia_cliente",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);    
            this.Comp_t=data;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! trinity', '', 'error');
          });
    
    }
    fn_competencias_t(){
      this.competence_v_t=true;
      this.per_competencia_t=[];
      this.hidCvePersona=this.id_persona;
      this.ls_percompetencias_t();
    }
    comp_evaluacion;
  comp_descripcion;
  comp_evaluacion_t;
  comp_descripcion_t;
  txtgrado="";
  modulo_comp(){
    //this.router.navigate([]).then(result => {  window.open('./#/competences', '_blank'); })
    //this.router.navigate(["/competences"]); 
    this.router.navigate(
      ['/competences'],
      { queryParams: { caller: 'perfil', callerant:"persona" } }
    );
  }
  nva_competencia_t(){
    this.competence_v_t=false;
    this.comp_ev=false;
  }
  comp_ev:boolean=false;
  txtanio:any;
  sel_t;
  _busper;
  can_pfpps(cve){
    let postData = {
      id_pfpps:cve
    }       
    //console.log(postData);
    this.authService.service("/api/del_pfpps",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('ok', '', 'success');
          let dat_={id:this.persona.id};
          this.pfp_ps(dat_);
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  
  }
  per_competencia;
  hidcompetenciaid;
  txtbusper="";
  cance_competencia_t(){
    this.competence_v_t=true;
  }
  _eval_;
  
  year_comp=0;
  v_eval(itm){
    this.loading=true
    let postData = {
      id_per_competencia:itm.id
    };
    
    
    
    this.authService.service("/api/get_evaluacion_percompetencia",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //console.log(res);
          this._eval_=res;
          this.loading=false;
          
  
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
            this.loading=false;
        });
  }
  bus_pfpps(){
    this._busper=[];
    
    let postData = {
      id_role:this.id_role,   
    persona:this.txtbusper,
    id_cliente:localStorage.getItem("id_cliente")
  }
  //console.log("bus_pfpps");
  //console.log(postData);
    this.authService.service("/api/bus_persona",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //console.log(res);
          this._busper=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  
  }
  edt_percomp_t(itm){
    //console.log(itm);
    this.hidcompetenciaid=itm.id;
    this.comp_ev=true;
    this.competence_v_t=false;
    this.comp_evaluacion_t=itm.evaluacion; 
    this.comp_descripcion_t=itm.descripcion;
    this.year_comp=0;
  }
  tpopfpps=0;
  nvo_pfpps(t){
    this.tpopfpps=t;
    this.v_pfpps=false;
    this.bus_pfpps();
  }
  ls_percompetencias(){
    let postData = {id_persona:this.hidCvePersona};
    this.authService.service("/api/get_per_competencia",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.per_competencia=data;
          }        
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
        });
  }
  evalua_competencia_t(){
    let postData = {
      id_per_competencia:this.hidcompetenciaid,
      id_evaluador:localStorage.getItem("usuario"),
      evaluacion:this.comp_evaluacion_t,
      descripcion:this.comp_descripcion_t
    };  
    //console.log(postData);
    this.authService.service("/api/eval_percompetencia",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.ls_percompetencias();
          this.competence_v=true;
          swal.fire('Ok', '', 'success');
          this.cance_competencia_t()
          this.fn_competencias_t();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
        });
  }
  del_we(itm){
    let postData = {
      id:itm.id
    }
    this.authService.service("/api/del_we",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('¡Ok!', '', 'success');
          this.get_we(); 
                    
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  
  }
  gda_pfpps(itm,t){
    //console.log("gda_pfpps");
    //console.log(itm)
    let postData = {
      tpo:t,
      id_persona:itm.id,
      id_role2:itm.id_role,
      id_role:this.id_role
    }
    //console.log
    //console.log(postData);
    this.authService.service("/api/gda_pfpps",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this._busper=res;
          let dat_={id:this.persona.id};
          this.pfp_ps(dat_);
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  del_educacion(itm){
    let postData = {
      id:itm.id
    }
    this.loading=true 
    this.authService.service("/api/del_educacion",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          
            this.get_education(this.hidCvePersona); 
            this.loading=false;   
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
            this.loading=false;
        });
  
  }
  ins_competencia_t(){
    let postData = {
      id_persona:this.id_persona,
      id_competencia:this.sel_t,
      id_role_card:0
    };
    if(this.sel_t==0)return;
    this.authService.service("/api/ins_percompetencia",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.ls_percompetencias_t();
          this.competence_v_t=true;
          swal.fire('Ok', '', 'success');
  
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
        });
  }
  del_percomp_t(id){
    if (!confirm("The data will be saved!"))return;
    let postData = {id_:id};
    this.authService.service("/api/del_percompetencia",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_percompetencias_t();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
        });
  
  }
  txtanio2=0;
  id_we=0;
  id_edu=0;
  descipcion_we="";
  descipcion_edu="";
  bndeditwe=false;
  bndeditedu=false;
  can_edu(){
    this.descipcion_edu=""
    this.bndeditedu=false;
  }
  upd_edu(){    
    let postData = {
      id:this.id_edu,
      educacion:this.txtgrado,
      escuela:this.txteducation,
      anio:this.txtanio_,
      anio2:this.txtanio2_    
    } 
    console.log(postData);
    this.authService.service("/api/upd_edu_persona",postData)
    .then(
        data => { 
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          for(var i=0;i<this.edu.length;i++){
            if(this.edu[i].id==this.id_edu){
              this.edu[i].educacion=this.txtgrado;
              this.edu[i].escuela=this.txteducation;
              this.edu[i].anio=this.txtanio_;
              this.edu[i].anio2=this.txtanio2_;
            }
          }
          this.txtgrado=""
          this.txteducation=""
          this.descipcion_edu="";
          this.txtanio_=null
          this.txtanio2_=null
          this.bndeditedu=false;
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  edit_edu(itm){
    this.id_edu=itm.id;
    this.txtanio_=itm.anio
    this.txtanio2_=itm.anio
    this.txteducation=itm.escuela
    this.txtgrado=itm.educacion
    this.descipcion_edu=itm.educacion;
    this.bndeditedu=true;
  }
  edit_we(itm){
    this.we.empresa=itm.empresa;
    this.we.posicion=itm.posicion;
    this.we.descripcion=itm.descripcion;
    this.id_we=itm.id;
    this.txtanio=itm.anio;
    this.txtanio2=itm.anio2;
    this.descipcion_we=itm.descripcion;
    this.bndeditwe=true;
  }
  gda_we(){
    //console.log(this.hidCvePersona);
    let postData = {
      anio:Number(this.txtanio),
      anio2:Number(this.txtanio2),
      id_persona:this.hidCvePersona,
      descripcion:this.we.descripcion,
      posicion:this.we.posicion,
      empresa:this.we.empresa
    } 
    this.loading=true;
    //console.log(postData);
    this.authService.service("/api/gda_we",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                        
          this.get_we(); 
          this.loading=false;
          swal.fire('¡ok!', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
            this.loading=false;
        });
  }
  gda_education(){
    this.loading=true;
    //console.log(this.txteducation);
    if(this.txteducation==null && this.txteducation==undefined)return;
    let postData = {
      id_persona:this.hidCvePersona,
      anio:Number(this.txtanio_),
      anio2:Number(this.txtanio2_),
      descripcion:this.txteducation,
      escuela:this.txtgrado
    } 
    //console.log(postData);
    this.authService.service("/api/gda_educacion",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
                     
          } 
          this.txteducation="";
          this.txtgrado="";
          this.txtanio_=undefined;
          this.txtanio2_=undefined;
          this.get_education(this.hidCvePersona); 
          this.loading=false 
          swal.fire('¡ok!', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false 
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  _can_pfpps(){
    this.v_pfpps=true;
  }
  fmt_assesment(){
    localStorage.setItem("id_persona",this.persona.id.toString());  
    localStorage.setItem("tpo","X");  
    console.log(this.persona);
    localStorage.setItem("nombre",this.persona.nombre+" "+this.persona.paterno+" "+this.persona.materno)  
    this.router.navigate([]).then(result => {  window.open('./#/assesment', '_blank'); });          
  }
    pfpps;
    v_pfpps:boolean=true;
    pfp_ps(itm){    
    console.log(itm);    
      this.v_pfpps=true;
      let postData = {
        id_persona:itm.id,
      }    
      //console.log(postData);
      this.authService.service("/api/get_pfpps",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            this.pfpps=res;
            //console.log(res);
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });
  
    }
    load_persona(itm){
      //console.log(itm);
      this.persona.id=itm.id;
      
      this.persona.foto=itm.foto;
      this.persona.nombre=itm.nombre;
      this.persona.paterno=itm.apaterno;
      this.persona.materno=itm.amaterno;
      this.persona.profesion=itm.profesion;
      //this.persona.role_id=itm.role;
    }
    ls_pfpps(){
      this.pfp_ps({id:this.id_persona});
    }
    chart(){
      this.selusu(this.id_role)
      //this.router.navigate(['/org'])
    }
    org_;
    nodes: any;
    get_nodes(id){      
      //console.log("get_nodes("+id+")")
      var child:any=[];
      var aux=[];
      for(var x=0;x<this.org_aux.length;x++){
        if (this.org_aux[x].idarea1==id){
          var foto_="";
          try {
              if (this.org_aux[x].foto.length>0){
              foto_="https://hoshinup.garocedev.com:3007/"+this.org_aux[x].foto;            
            }else{
              foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
            }
          } catch (error) {
            foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
          }
          var name=this.org_aux[x].role_card
          var css='{"id_persona":'+this.org_aux[x].id+',"id_role":'+this.org_aux[x].id_role+'}'
          var title=this.org_aux[x].persona
          var id_role=this.org_aux[x].id_role
          //this.org_aux.splice(x, 1);

          child.push({
            image: foto_,
            name:name,
            cssClass:css,
            title:title,
            childs:this.get_nodes(id_role)
          });
          
        }
          
      }
      return child;
    }  
    org_aux;
    opt:any="vertical";
    selusu(id){
      this.org_aux=this.org;
      //console.log(this.org); 
      for(let i=0;i<this.org.length;i++){
        if(this.org[i].id_role==id){
          var foto_="";
          if (this.org[i].foto==""){
            foto_="https://hoshinup.garocedev.com:3007/"+this.org[i].foto;            
          }else{
            foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
          }
          var name=this.org[i].role_card
          var css='{"id_persona":'+this.org[i].id+',"id_role":'+this.org[i].id_role+'}'
          var title=this.org[i].persona
          var id_persona=this.org[i].persona
          var id_role=this.org[i].id_role
      
          //this.org_aux.splice(i, 1);
          
            this.nodes=[{
            name:name,
            cssClass:css,
            image:foto_,
            title:title, 
            childs:this.get_nodes(id_role)
            }];
            
        }
      }
    }
    editar_persona(){
      
    }
    fn_format(t){
      switch (Number(t)) {
        case 1:case 2:
          this.hidCvePersona=this.id_persona;
          localStorage.setItem("id_persona",this.hidCvePersona);
          localStorage.setItem("tprint",t);
          this.router.navigate([]).then(result => {  window.open('./#/fmt112', '_blank'); });          
          break;  
        default:
          this.hidCvePersona=this.id_persona;
          localStorage.setItem("id_persona",this.hidCvePersona);
          localStorage.setItem("tprint",t);
          this.router.navigate([]).then(result => {  window.open('./#/role', '_blank'); });  
          break;
      }
      //console.log(itm);
      
     // this.print();
    }
    ls_percompetencias_t(){
      let postData = {id_persona:this.id_persona};
      this.authService.service("/api/get_per_competencia_trinity",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);    
            this.per_competencia_t=data;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta!', '', 'error');
          });
    }
    get_education(cve){
      let postData = {
        id_persona:this.hidCvePersona,
      } 
      //console.log(postData);
      this.authService.service("/api/get_educacion",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            this.edu=res;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });
    }
    fn_edu(){
      this.txteducation=""
      this.txtanio_=undefined;
      this.txtanio2_=undefined;
      this.edu=[];
      this.hidCvePersona=this.id_persona;
      this.get_education(this.id_persona);
    }
    we_=[];
    get_we(){
      let postData = {
        id_persona:this.id_persona
      }
      console.log(postData)
      this.authService.service("/api/get_we",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                       
            this.we_=data;          
                     
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });
  
    }
    we={
      anio:0,
      empresa:"",
      posicion:"",
      descripcion:""
    };
    can_we(){
      this.descipcion_we=""
      this.bndeditwe=false;
    }
    upd_we(){    
      let postData = {
          id:this.id_we,
          anio:this.txtanio,
          anio2:this.txtanio2,
          empresa:this.we.empresa,  
          posicion:this.we.posicion,  
          descripcion:this.we.descripcion,  
        } 
      console.log(postData);
      this.authService.service("/api/upd_we_persona",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            for(var i=0;i<this.we_.length;i++){
              if(this.we_[i].id==this.id_we){
                this.we_[i].anio=this.txtanio;
                this.we_[i].anio2=this.txtanio2;
                this.we_[i].empresa=this.we.empresa;
                this.we_[i].posicion=this.we.posicion;
                this.we_[i].descripcion=this.we.descripcion;                
              }
            }
            this.txtanio=null;
            this.txtanio2=null;
            this.we.empresa="";
            this.we.posicion="";
            this.we.descripcion="";
            this.bndeditwe=false;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });
    }
    fn_we(){
      this.bndeditwe=false;
      this.we.empresa="";
      this.txtanio_=null;
      this.txtanio2=null;
      this.we.descripcion="";
      this.hidCvePersona=this.id_persona;
      this.get_we();
    }
    fn_goals(){
     
      this.goal_e=false;
      this.goal_v=false;
      this.hidCvePersona=this.id_persona;
      this.txtgoals="";
      this.ls_goals();
    }
    fn_nva_comp(){
      this.router.navigate(["/competences"]); 
      this.router.navigate(
        ['/competences'],
        { queryParams: { caller: 'perfil', callerant:"persona" } }
      );
    }
    fn_idp(){
      this.hidCvePersona=this.id_persona; 
      //console.log(itm);
      this.idp=[];
      this.ls_idp(this.id_persona);  
      this.ls_competencias();
      this.idp_v=true;
      this.feed_area=false;
     this.idp_area=true;
    }
    idp_=
    {
      id:0,
      skill:0,
      trainig:"",
      periodo:0,
      fecha:"",
      fecha2:"",
      lugar:"",
      complete:0,
      t_complete:"",
      tiempo:0,
      tiempo_:"",
      costos:0,
      resultados:"",
      estatus:'A'
    };
    lista_gaol(){
      this.goal_v=false;
      this.goal_e=false;
    }
    gdahk_goals(){
      let postData = {
        id_goal:this.hidid_goal,
        evaluacion:this.ev_goals,
        id_evaluador:localStorage.getItem("usuario"),
        
        descripcion:this.txtdescgoals
      };
      //console.log(postData);
      this.authService.service("/api/ins_evalgoalshk",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            swal.fire('Ok', '', 'success');
            this.ls_goals();        
            this.goal_v=false;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! idp', '', 'error');
          });    
    }
    org_pd=[];
    get_org(){  
      let postData = {
        id_cliente:localStorage.getItem("id_cliente")
      }       
      this.authService.service("/api/get_org_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.org=data; 
            for(var i=0;i<this.org.length;i++){
              //console.log(this.org[i]);
              if(this.org[i].organo=='D' ||this.org[i].organo=='P'){
                this.org_pd.push(this.org[i]);
              }
            }         
            console.log(data) 
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });             
    }
    ls_goals_hk(){  
      let postData = {
        id_cliente:localStorage.getItem("id_cliente")
      }       
      this.authService.service("/api/get_org",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.org=data;
            var bnd=0;
            /*for(var i=0;i<this.org.length;i++){              
              if(this.org[i].director==1){
                if(bnd==0){               
                  this.duenio_id_n1= this.org[i].id_role;  
                  bnd=1;
                }
              }              
            }  */
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });                
          let postData2 = {
            id_hk:this.proyecto,
            usu:this.id_role,
            id_responsable:this.id_role
          }      
          var api="/api/despliegue_usu";
          if(this.duenio_id_n1==this.id_role){        
            api="/api/despliegue_resp";
          }
          this.authService.service(api,postData)
          .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);  
              this.despliegue_=res;          
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡Información incorrecta!', '', 'error');
            });
      
      
    
    }
    proyecto;
    duenio_id_n1=0;
    duenio_id_nr="";
    org;
  
  id_evlhk=0;
    despliegue_=[];
    fn_nvo_goal(){
      this.goal_v=true;
      this.bndgoal_hk=false;
      this.goal_n=true;
      this.id_evlhk=0;
    }
  _evalgoalhk=[];
  del_evaluate_goal(itm){
    if(confirm("Confirm to delete this row?")==false)return;
    let postData = {
      id:itm.id   
    }
    
    this.authService.service("/api/del_goal",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_goals();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });  
  }
  ins_goal_hk(itm){
    this.id_evlhk=itm.id;
    this.txtgoals="[HK]-"+itm.nombre;
    this.bndgoal_hk=false;
    this.goal_n=true;
  }
  ins_goals(){
    let postData = {
      id_persona:this.hidCvePersona,
      goal:this.txtgoals,
      fecha:this.date_goal,
      id_hk:this.id_evlhk
    };
    this.authService.service("/api/ins_goals",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('Ok', '', 'success');
          this.ls_goals();        
          this.goal_v=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });    
  }
  evaluate_goal(itm){
    
    this.hidid_goal=itm.id;
    this.txtdescgoals="";
    this.ev_goals=0;
    /*
    this.txtdescgoals=itm.descripcion;
    this.ev_goals=itm.evaluacion;
    */
    this.goal_v=true;
    this.goal_e=true;
    this.goal_n=false;
    this.bndgoal_hk=false;
  }
  insall_goal_hk(){
    let postData = {
      id_persona:this.id_role,
      
    };
    console.log(postData);
    this.authService.service("/api/ins_allgoals",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('Ok', '', 'success');
          this.ls_goals();        
          this.goal_v=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });  
  
  }
    evalgoalhk(itm){
      let postData = {  
        id_goal:itm.id
      };
      console.log("evalgoalhk");
      console.log(postData);
      this.authService.service("/api/get_evalgoalshk",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            //swal.fire('Ok', '', 'success');
            console.log(this._evalgoalhk);
            this._evalgoalhk=res;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! idp', '', 'error');
          });    
    
    }
    ls_goals(){
      let postData = {
        id_persona:this.id_persona
      };
      //console.log(postData);
      this.authService.service("/api/get_goals",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            
            this.goals=data;
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! goal', '', 'error');
          });    
    }
    upd_goals(){
      let postData = {
        id_goal:this.hidid_goal,
        goal:this.txtgoals,
        evaluacion:this.ev_goals,
        descripcion:this.txtdescgoals
      };
      this.authService.service("/api/upd_goals",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            swal.fire('Ok', '', 'success');
            this.ls_goals();        
            this.goal_v=false;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! idp', '', 'error');
          });    
    }
    metashk=[];
    idp_a:boolean=true;
    can_inscomp(){
      this.competence_v_t=true 
    }
    fn_updidp(){
    if(this.valida_idp()==false)return;
    let postData = {
      id:this.idp_.id,
      id_competencia:this.idp_.skill,
      actividades:this.idp_.trainig,
      fecha:this.idp_.fecha,
      fecha2:this.idp_.fecha2,
      lugar:this.idp_.lugar,
      complete:this.idp_.complete,
      t_complete:this.idp_.t_complete,
      costo:this.idp_.costos,
      resultado:this.idp_.resultados,
      periodo:this.idp_.periodo,
      estado:this.idp_.estatus   
    };
    console.log(postData) 
    this.authService.service("/api/upd_idp_2",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.idp_v=true;
          swal.fire('Ok', '', 'success');
          this.ls_idp(this.hidCvePersona);
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta! idp', '', 'error');
        });  
    }
    
    fn_insidp(){
      if(this.valida_idp()==false)return;
      let postData = {
          id:this.idp_.id,
          id_persona:this.hidCvePersona,
          id_competencia:this.idp_.skill,
          actividades:this.idp_.trainig,
          fecha:this.idp_.fecha,
          fecha2:this.idp_.fecha2,
          lugar:this.idp_.lugar,
          complete:this.idp_.complete,
          t_complete:this.idp_.t_complete,
          costo:this.idp_.costos,
          resultado:this.idp_.resultados,
          periodo:this.idp_.periodo,
          estado:this.idp_.estatus    
      };
      console.log(postData);
      this.authService.service("/api/ins_idp_2",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            this.idp_v=true;        
            this.ls_idp(this.hidCvePersona);
            swal.fire('Ok', '', 'success');
            var postD={
              prioridad:0,
              id_cliente:localStorage.getItem("id_cliente"),
              task:{
                id_task:0,
                status:'A',
                delega:0,
                asignadoa:this.id_persona,
                fini:this.idp_.fecha,
                ffin:this.idp_.fecha2,
                nombre:"IDP: "+this.idp_.trainig,
                tipo:0

              }              
            };
            console.log(postD)
            this.authService.service("/api/sp_task_test_vacio",postD)
              .then( data => {});
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              console.log(error);
              swal.fire('API incorrecta! idp', '', 'error');
          });  
    
    }
    goals;
    
    txtgoals:any;
    txtdescgoals:any;
    goal_n:boolean=false;
    goal_v:boolean=false;
    bndgoal_hk:boolean=false;
    hidid_goal:number=0;
  goal_e:boolean=false;
  ev_goals:number=0;
    competencias=[];
    competencias_=[];
    idp_v:boolean=true;
    ls_competencias(){
      let postData = {        
        id_cliente:localStorage.getItem("id_cliente")
      };
      this.authService.service("/api/get_competencia_cliente",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.competencias=data;
              this.competencias_=data;
              //console.log(res);          
            }
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! idp', '', 'error');
          });  
    }
    ls_idp(id_){
      let postData = {id_persona:id_}
      this.authService.service("/api/get_idp",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.idp=data;
              //console.log(res);          
            }
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta! idp', '', 'error');
          });  
    
    }
    valida_idp(){
      return true;
    }
  
    _show(c){
      switch (c) {
        case 'IDP':this.container_p=2;this.idp_area=true;break;
        case 'GOALS':this.container_p=3;break;
        case 'WE':this.container_p=4;break;
        case 'PC':this.container_p=5;break;
        case 'Edu':this.container_p=6;break;
        case 'PFP':this.container_p=7;break;
        case 'PS':this.container_p=8;break;
        case 'AS':this.container_p=9;break;
        case 'FMT':this.container_p=10;break;    
        default:
          break;
      }
    }
    nombre="";
    paterno="";
    materno="";
    limpia_nombre(){ 
      this.persona.nombre="";
      this.persona.paterno="";
      this.persona.materno="";
      this._persona=this._personaaux;
    }
    _personaaux;
    bus_persona(){
      console.log("ok")
      var _per=[];
      //console.log(this.persona);
      for(var i=0;i<this._personaaux.length;i++){
        console.log(this._personaaux[i])
        if( this._personaaux[i].nombre.toLowerCase().includes(this.persona.nombre.toLowerCase()) && 
            this._personaaux[i].apaterno.toLowerCase().includes(this.persona.paterno.toLowerCase()) &&
            this._personaaux[i].amaterno.toLowerCase().includes(this.persona.materno.toLowerCase())   ){
              _per.push(this._personaaux[i]);
        }      
      }
      this._persona=_per;
    }
    role_name="";
    valida_per2(){
      if(this.persona.nombre==undefined){
        swal.fire('Name Incomplete!', '', 'error');
        return false;
      }
      if(this.persona.paterno==undefined && this.persona.paterno==""){
        swal.fire('Fathers Surname Incomplete!', '', 'error');
        return false;
      }    
      
      
      return true;
    }
   
    uploadFileToActivity(){
      //console.log("upload");
       
        if (this.fileToUpload) {
          var reader = new FileReader();
          
          reader.readAsDataURL(this.fileToUpload); // read file as data url
          const file = this.fileToUpload;
          
          reader.onload = (event) => { 
            this.URL = reader.result;
      
            var tmpDate = new Date();     //  Wed Oct 16 2013 12:37:29 GMT+0200
            var now = tmpDate.getTime();
            let data: any = {
              cveentevt: 1,
              name: now + '.' + this.ext_(file.type),
              firma: this.URL,
              idx: 1,
              id_persona:this.hidCvePersona
            }
            
            
            this.persona.foto=data.name;
            data.TYPE = 'pdf';
            data.FILENAME = 'files/' + now + '.pdf',
            
             //this.loading =true;
            console.log(data);
              
              this.authService.upImagen(data).then(res => {
                var mm = JSON.stringify(res)
                var dd = JSON.parse(mm)
                this.msg_foto="<span class=green>✔</span> ";
                //console.log("guardado");
                //this.img1.id = res[0].cveevtanx;
                //this.img1.url = this.urlwebimg +  now + ".png";
                this.txt_fot=  now + ".png" 
                //this.loading =false;
                  //this.PDF =  dd.detailed_message            
                //swal.fire('DOCUMENTO SE GUARDO EXITOSAMENTE','DOCUMENTO SE GUARDO EXITOSAMENTE','success')
                  // console.log(dd.detailed_message)              
                for(var i=0;this._persona.length;i++){
                  if(this._persona[i].id==this.hidCvePersona){
                    this._persona[i].foto=data.name;
                  }
                }
              },error => {
                this.msg_foto=" <span style=color:red;>X error</span> ";
              }
              )
            }
          }
      }
      hidCvePersona;
      txt_fot;
  
    _regresa(){
      this.VentanaFix=0;
    }
    public URL:any;
  public evento:any;
  public img1:any;
  public urlwebimg:any;
  public msg_foto:any;
   ext_(f:any) {
     //console.log(f);
     var c:string[]=f.split("/");
    return c[(c.length-1)]; 
  }
  fileToUpload: File = null;
  onSelectFile(event,idx) {
    //console.log(event);
    this.URL = event.target.files;
    this.fileToUpload = event.target.files[0];
  }
    container_p=0;
    persona={
      id:0, 
      id_role:0, 
      foto:"",
       nombre:"",
       paterno:"",
       materno:"",
       profesion:"",
       fec_ingreso:"",  
       email:"",
       telefono:"",
       celular:"",   
       chart:0,
       puesto:""
     };
  


    ////////////// ARTURO //////////////
    cda:any;
    kdr:any;
    kpi:any;
    dke:any; 
    we1:any;
    edu1:any;
    jcom:any;
    phy:any;

    exp={
      id:0,
      posicion:"",
      txdirRep1:"",
      txdirRep2:"",
      descripcion:""
    }
    _mAre1;
    _mAre2;

    async get_experience(id_){
      let postData = {
        id:id_ 
      } 
        //console.log(postData);
       await this.authService.service("/api/get_experience",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);
                //console.log(res[0]);              
                this.exp.id=res[0].id;
                this.exp.posicion=res[0].titulo;
                this.exp.descripcion=res[0].descripcion;
                this._mAre1=res[0].idarea1;
                this._mAre2=res[0].idarea2;
                this.exp.txdirRep1=res[0].txdirRep1;
                this.exp.txdirRep2=res[0].txdirRep2;
                        
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡API incorrecta! exp', '', 'error');
            });   
    }
    async ls_we(id_){
      let postData = {id_role:id_} 
      await this.authService.service("/api/get_we_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            
            this.we1=data;
            
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });  
    }
    async ls_cda(id_){
      let postData = {id_role:id_} 
      await this.authService.service("/api/get_cda_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.cda=data;
            } 
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });  
    }
    async ls_kdr(id_){
      let postData = {id_role:id_  } 
      await this.authService.service("/api/get_kdr_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.kdr=data;
            } 
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });
    }
    async ls_kpi(id_){
      let postData = {id_role:id_ } 
      await this.authService.service("/api/get_kpi_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.kpi=data;
            } 
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });
    }
    async ls_dke(id_){
      let postData = { id_role:id_ } 
      await this.authService.service("/api/get_dke_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.dke=data;
            } 
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });
    } 
    async ls_edu(id_){
      let postData = {id_role:id_} 
      await this.authService.service("/api/get_educacion_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
              this.edu1=data;
            
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });  
    }
    async ls_jcom(id_){
      let postData = {id_role:id_} 
      await this.authService.service("/api/get_jcom",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            this.jcom=data;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });  
    }
    async ls_phy(id_){
      let postData = {id_role:id_} 
      await this.authService.service("/api/get_pdwe_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);    
              this.phy=data;          
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });  
    }

    getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
    
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
    
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
    
        var dataURL = canvas.toDataURL("image/png");
    
        resolve(dataURL);
      };
    
      img.onerror = error => {
        reject(error);
      };
    
      img.src = url;
    });
    }

    itm = {
      area: "",
      chart: 0,
      departamento: "",
      descripcion: "",
      directo: 0,
      estatus: "",
      id: 0,
      id_cliente: 0,
      id_departamento: 0,
      id_persona: 0,
      idarea1: 0,
      idarea2: 0,
      idarea3: 0,
      idx: 0,
      lider: 0,
      nivel: 0,
      organo: "",
      pg: 0,
      sufijo: "",
      titulo: "",
    }
    
    async ls_pdf(){            
      this.loading = true;
       
      
      await this.ls_cda(this.persona.id_role);    
      await this.ls_kdr(this.persona.id_role);
      await this.ls_kpi(this.persona.id_role);
      await this.ls_dke(this.persona.id_role);
      await this.ls_we(this.persona.id_role);
      await this.ls_edu(this.persona.id_role);
      await this.ls_jcom(this.persona.id_role);    
      await this.ls_phy(this.persona.id_role);
      await this.get_experience(this.persona.id);
      
      var sReportto=this.exp.txdirRep1;
                
      var vCol1 =  Array();    
      var vCol2 =  Array();    
  
      
      vCol1.push({ 
          table: {
            widths: ['*'],
            body: [              
                [{ text: 'Job details', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
            ]
          },
      });
      
      vCol1.push({
        text: [  
          { text: '• ', fontSize: 10 , bold: true, color: 'darkblue'},
          { text: 'Reports to: ', fontSize: 9 , bold: true, color: 'darkblue'},
          { text: sReportto, fontSize: 8 , alignment:'left'}            
        ]
      });
      vCol1.push({
        text: [       
        { text: '• ', fontSize: 10 , bold: true, color: 'darkblue'},
        { text: 'Direct reports: ', fontSize: 9 , bold: true, color: 'darkblue'},
        { text: "itm.departamento", fontSize: 8 , alignment:'left'}
        ]
      });
      vCol1.push({
        text: [      
        { text: '• ', fontSize: 10 , bold: true, color: 'darkblue'},
        { text: 'Description: ', fontSize: 9 , bold: true, color: 'darkblue'},
        { text: this.exp.descripcion, fontSize: 8 , alignment:'justify'}
        ]
      });

      
      
      //CDA    
      vCol1.push({ 
          table: {
            widths: ['*'],
            body: [
                [{ text: 'Critical deliverables / accountabilities', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
            ]
          },
      });
        
      
      for (let i = 0; i<this.cda.length; i++){
        vCol1.push({
          text: [       
            { text: '• ', fontSize: 10 , bold: true},
            { text: this.cda[i].descripcion, fontSize: 8 , alignment:'justify'}            
          ]
        });      
      }
            
        
      //KDR     
      vCol1.push({ 
          table: {
            widths: ['*'],
            body: [
                [{ text: 'Key decision rights', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
            ]
          },
      });
  
      for (let i = 0; i<this.kdr.length; i++){
        vCol1.push({
          text: [       
            { text: '• ', fontSize: 10 , bold: true},
            { text: this.kdr[i].descripcion, fontSize: 8 , alignment:'justify'}            
          ]
        });      
      }
        

      //KPI     
      vCol1.push({ 
          table: {
            widths: ['*'],
            body: [
                [{ text: 'Key performance indicators', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
            ]
          },
      });
  
      for (let i = 0; i<this.kpi.length; i++){
        vCol1.push({
          text: [       
            { text: '• ', fontSize: 10 , bold: true},
            { text: this.kpi[i].descripcion, fontSize: 8 , alignment:'justify'}            
          ]
        });      
      }
  
      //DKE     
      vCol2.push({ 
          table: {
            widths: ['*'],
            body: [
                [{ text: 'Desired knowledge and experience', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
            ]
          },
      });
        

      for (let i = 0; i<this.dke.length; i++){
        vCol2.push({
          text: [       
            { text: '• ', fontSize: 10 , bold: true},
            { text: this.dke[i].descripcion, fontSize: 8 , alignment:'justify'}            
          ]
        });      
      }
  
  
      //WE     
      vCol2.push({ 
          table: {
            widths: ['*'],
            body: [
                [{ text: 'Work experience', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
            ]
          },
      });
  
      for (let i = 0; i<this.we1.length; i++){
        vCol2.push({
          text: [       
            { text: '• ', fontSize: 10 , bold: true},
            { text: this.we1[i].descripcion, fontSize: 8 , alignment:'justify'}            
          ]
        });      
      }
  
      //EDU
      vCol2.push({ 
          table: {
            widths: ['*'],
            body: [
                [{ text: 'Education', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
            ]
          },
      });
  
      for (let i = 0; i<this.edu1.length; i++){
        vCol2.push({
          text: [       
            { text: '• ', fontSize: 10 , bold: true},
            { text: this.edu1[i].educacion, fontSize: 8 , alignment:'justify'}            
          ]
        });      
      }
  
      //JCOM
      vCol2.push({ 
          table: {
            widths: ['*'],
            body: [
                [{ text: 'Job Competences', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
            ]
          },
      });
  
      for (let i = 0; i<this.jcom.length; i++){
        vCol2.push({
          text: [       
            { text: '• ', fontSize: 10 , bold: true},
            { text: this.jcom[i].competencia, fontSize: 8 , alignment:'justify'}            
          ]
        });      
      }
  
  
      //PHY
      vCol2.push({ 
          table: {
            widths: ['*'],
            body: [
                [{ text: 'PHYSICAL DEMANDS AND WORK ENVIRONMENT', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
            ]
          },
      });
  
      for (let i = 0; i<this.phy.length; i++){
        vCol2.push({
          text: [       
            { text: '• ', fontSize: 10 , bold: true},
            { text: this.phy[i].descripcion, fontSize: 8 , alignment:'justify'}            
          ]
        });      
      }
      
  
  
      const pdf = new PdfMakeWrapper();      
      pdf.pageSize('letter');    
      pdf.pageOrientation("landscape");   
      pdf.pageMargins([20, 50, 20, 50]);  
  
  
  
      var header = (pagenumber: number, pagecount: number) => {return {alignment:"center",fontSize:12, margin: [15,15],
      
      table: {
        widths: [630,100],
        body: [
            [
              {text: "Position title: " + this.persona.puesto ,alignment:'left', bold: true, color: '#000', fillColor:'#fff', border: [false, false, false, false]},
              {        
                table: {
                    widths: [100],
                    body: [
                        [{ text: 'WORKING DRAFT', bold: true , border: [true, false, false, true],alignment:'right', }],
                    ]
                }, border: [false, false, false, false]
              },
            ],
            
        ]
      }
      }; };
      pdf.header(header);
      
  
      pdf.add(new Table([
        
        [
          vCol1,
          {},
          vCol2,
        ]
      ])
      .layout("noBorders").widths([360,10,360]).fontSize(9).end);  
  
     
      var ima = await this.getBase64ImageFromURL("https://hoshinup.garocedev.com/raci2/assets/trinity-footer1.png");
      var footer = (pagenumber: number, pagecount: number) => {return {alignment:"center",fontSize:12, margin: [15,0],
      
      table: {
        widths: [680,'*'],
        body: [
            [
              {image: ima , width: 680, height: 30, border: [false, false, false, false]},
              {text: pagenumber + ' de ' + pagecount, border: [false, false, false, false]}
            ],
            
        ]
      }
  
  
      }; };
      pdf.footer(footer);
  
      this.loading = false;
      pdf.create().open();    
    }

    winprepdf:boolean = false;
    siz; selsiz;
    ori; selori;
    scale; selscale;
    itmmargin = { top:1, bottom:1, right:1, left:1, };
    margin = [];

    ls_prevpdf(){
      this.winprepdf = true;
      var siz = [];
      siz.push({  nombre:"Letter" });
      siz.push({  nombre:"Executive" });
      siz.push({  nombre:"Legal" });
      siz.push({  nombre:"Tabloid" });    
      this.siz = siz;

      var ori = [];
      ori.push({  nombre:"true", valor:true });
      ori.push({  nombre:"false", valor:false });
      this.ori = ori;


      var scale = [];
      scale.push({  nombre:.1  });
      scale.push({  nombre:.2  });
      scale.push({  nombre:.3  });
      scale.push({  nombre:.4  });
      scale.push({  nombre:.5  });
      scale.push({  nombre:.6  });
      scale.push({  nombre:.7  });
      scale.push({  nombre:.8  });
      scale.push({  nombre:.9  });
      scale.push({  nombre:1  });      
      this.scale = scale;

    }
  
    ls_pdfSave(){
      this.loading= true;
      this.margin = [];
      this.margin.push
      ({ 
        top: this.itmmargin.top.toString()+"cm", 
        bottom:this.itmmargin.bottom.toString()+"cm", 
        right:this.itmmargin.right.toString()+"cm", 
        left:this.itmmargin.left.toString()+"cm",
      });

      setTimeout(() => { 
        this.pdf.saveAs("chart_"+ + new Date().getTime() + ".pdf");   
        this.loading= false;
      }, 1000);
    }

    _go(){      
      this.router.navigate([this.caller]);
    }

  }
